module.exports = __webpack_public_path__ + "img/ic_not.a9a261b6.svg";